module.exports = __webpack_public_path__ + "d5a576b9ea0991265e90a1f6d55c0aa1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/attachment_comment.svg
// module id = wMes
// module chunks = 1